<script setup lang="ts">
import type { ImageListItem } from '#shared/types/entity'

import { computed } from 'vue'

import { useActiveCity } from '~/composables/useActiveCity'

// Фото сервиса города (из карточки Яндекса, привязаны к точке в CMS) — вместо блока работ
// в регионе без своих кейсов. Без описаний работ, сроков и сумм.
const props = defineProps<{
  images: readonly ImageListItem[]
  address?: string | undefined
  // Ссылка на страницу с фото сервиса (/work региона без кейсов); на самой странице не нужна.
  moreHref?: string | undefined
}>()

const activeCity = useActiveCity()

const title = computed<string>(() => {
  const cityLocative = activeCity.value?.name_locative?.trim()
  return cityLocative ? `Наш сервис ${cityLocative}` : 'Наш сервис'
})

const galleryImages = computed<ImageListItem[]>(() => [...props.images])
</script>

<template>
  <div class="space-y-6">
    <CenteredTitle class="text-left">{{ title }}</CenteredTitle>
    <p v-if="address" class="text-base">{{ address }}</p>
    <Gallery :images="galleryImages" />
    <div class="flex flex-wrap gap-x-6 gap-y-2">
      <NuxtLink
        v-if="moreHref"
        :to="moreHref"
        class="text-brand-red inline-block text-base font-semibold underline-offset-4 hover:underline">
        Все фото сервиса
      </NuxtLink>
      <NuxtLink
        to="/kontaktyi"
        class="text-brand-red inline-block text-base font-semibold underline-offset-4 hover:underline">
        Контакты и схема проезда
      </NuxtLink>
    </div>
  </div>
</template>
